import { FormControlLabel, Checkbox } from "@mui/material";
import {
  IAdditionalQuestion,
  ICheckboxQuestion,
  IRateAppointment,
} from "../interface/iRateAppointment";
import { RateAppointmentContext } from "../context/rateAppointmentContext";
import React from "react";

const CheckBoxQuestion = ({
  question,
  index,
  additionalQuestionIndex,
  identifier,
}: {
  question: ICheckboxQuestion;
  index: number;
  additionalQuestionIndex?: number;
  identifier: string;
}): React.JSX.Element => {
  const {
    rateAppointmentDto,
    setRateAppointmentDto,
    isLoading,
  }: {
    rateAppointmentDto: IRateAppointment;
    setRateAppointmentDto: React.Dispatch<
      React.SetStateAction<IRateAppointment>
    >;
    isLoading: boolean;
  } = React.useContext(RateAppointmentContext);

  // Function to handle the change event of the checkbox
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // Prevent the default behavior of the checkbox
    event.preventDefault();

    // Prevent the event from bubbling up to parent elements
    event.stopPropagation();

    // Update the state with the new checked value
    // Create a new array to avoid mutating the original state
    const newCheckboxQuestions =
      identifier === "speakWithCoachQuestions"
        ? [...rateAppointmentDto.speakWithCoachQuestions]
        : [...rateAppointmentDto.additionalQuestions];

    // Update the specific question's checked value
    // This is done by creating a new object with the updated value and replacing the old object in the array
    // This ensures that React can detect the change and re-render the component when necessary
    newCheckboxQuestions[index] = {
      ...newCheckboxQuestions[index],
      checked: event.target.checked,
    };

    // Update the state with the new array
    if (identifier === "speakWithCoachQuestions") {
      setRateAppointmentDto({
        ...rateAppointmentDto,
        speakWithCoachQuestions: newCheckboxQuestions as ICheckboxQuestion[],
      });
    } else {
      // Create a new array to avoid mutating the original state
      const updatedAdditionalQuestions: IAdditionalQuestion[] = [
        ...rateAppointmentDto.additionalQuestions,
      ];

      // Update the specific question's checked value
      updatedAdditionalQuestions[additionalQuestionIndex as number].questions[
        index
      ].checked = event.target.checked;

      // Update the state with the new array
      setRateAppointmentDto({
        ...rateAppointmentDto,
        additionalQuestions: updatedAdditionalQuestions,
      });
    }
  };

  return (
    <FormControlLabel
      sx={{
        "&:hover": {
          textDecoration: "underline",
        },
        width: "100%",
        mb: 1,
      }}
      control={
        <Checkbox
          disabled={isLoading}
          checked={question.checked}
          onChange={handleOnChange}
          color="secondary"
          inputProps={{ "aria-label": "controlled" }}
        />
      }
      label={question.text}
    />
  );
};

export default CheckBoxQuestion;
